import { Connection, EntitySubscriberInterface, InsertEvent } from 'typeorm';
import { EventEmitter2 } from '@nestjs/event-emitter';
import { Inject, Injectable } from '@nestjs/common';
import { InjectConnection } from '@nestjs/typeorm';
import { OtpEntity } from '@ip6m/server/data-access-otp';
import { UserDataService } from '@ip6m/server/data-access-user';
import { FRONTEND_BASE_URL } from '@ip6m/server/config';
import { Loggable } from '@ip6m/server/shared';
import { EmailNotificationEvent } from '@ip6m/server/feature-notification';

@Injectable()
export class OtpEntitySubscriber
  implements EntitySubscriberInterface<OtpEntity> {
  constructor(
    @InjectConnection() connection: Connection,
    private eventEmitter: EventEmitter2,
    private userDataService: UserDataService,
    @Inject(FRONTEND_BASE_URL) private frontendBaseUrl: string
  ) {
    connection.subscribers.push(this);
  }

  listenTo() {
    return OtpEntity;
  }

  @Loggable
  async afterInsert(event: InsertEvent<OtpEntity>) {
    const otp = event.entity;
    const user = await this.userDataService.get(otp.userId);

    this.eventEmitter.emit(
      'notification.email',
      new EmailNotificationEvent({
        message: `Your can login via the following link: ${this.frontendBaseUrl}/auth/one-time-password?email=${user.email}&otp=${otp.otp}`,
        subject: 'One time password created',
        toEmailAddress: user.email,
      })
    );
  }
}
